<template>
  <page :title="user ? 'User - #' + user.id : ''" :backTo="getPreviousUrl" :loading="user === null">
    <div slot="page-header-right">
      <b-dropdown position="is-bottom-left">
        <button class="button" slot="trigger">
          <b-icon icon="dots-horizontal"></b-icon>
        </button>

        <b-dropdown-item @click="sendPasswordResetLink">Send a link to reset password</b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="box" v-if="user">
      <div class="level">
        <div class="level-left">
          <div class="media" style="align-items: center;">
            <figure class="media-left">
              <p class="image is-64x64">
                <img :src="user.profile_picture.sm" :alt="user.name" class="is-circle"
                  style="width: 64px; height: 64px;" />
              </p>
            </figure>
            <div>
              <div class="title is-5">{{ user.name }}</div>

              <div class="subtitle">{{ user.email }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="user">
      <div class="tabs is-marginless">
        <ul>
          <router-link tag="li" :to="`/users/${user.id}`">
            <a>General</a>
          </router-link>

          <router-link tag="li" :to="`/users/${user.id}/devices`">
            <a>Devices</a>
          </router-link>

          <router-link tag="li" :to="`/users/${user.id}/downloads`">
            <a>Downloads</a>
          </router-link>

          <router-link tag="li" :to="`/users/${user.id}/views`">
            <a>Views</a>
          </router-link>

          <router-link v-if="$store.getters.hasSubscription" tag="li" :to="`/users/${user.id}/purchases`">
            <a>Purchases</a>
          </router-link>
        </ul>
      </div>

      <div class="card-content">
        <router-view :user="user"></router-view>
      </div>
    </div>
  </page>
</template>

<script>
import SendPasswordResetLinkModal from "./components/SendPasswordResetLinkModal";

export default {
  data() {
    return {
      user: null
    };
  },
  computed: {
    getPreviousUrl() {
      return localStorage.getItem('previous');
    },
  },

  created() {
    this.load();
  },

  watch: {
    $route() {
      this.load();
    }
  },

  methods: {
    load() {
      this.$http
        .get("/admin/api/users/" + this.$route.params.id)
        .then(response => {
          this.user = response.data.data;
        })
        .catch(() => {
          alert("Couldn't fetch data from the server.");
        });
    },

    sendPasswordResetLink() {
      this.$buefy.modal.open({
        component: SendPasswordResetLinkModal,
        props: {
          userId: this.user.id
        }
      });
    }
  }
};
</script>
